export const RENDER_DEPTH = Object.freeze({
  background: 0,
  environmentalBack: 5,
  groundDecals: 10,
  placement: 20,
  groundShadows: 30,
  units: 40,
  projectiles: 50,
  combatEffects: 60,
  healthBars: 70,
  selection: 80,
  hud: 100,
  screenOverlay: 120,
});

export const MAP_TEXTURE = Object.freeze({
  key: "map-castle-approach",
  width: 24 * 48,
  height: 16 * 48,
  logicalTileSize: 48,
});

export const DEBUG_RENDER_DEFAULTS = Object.freeze({ grid: false, navigationPath: false });
